__turbopack_context__.v({
  "mergedRow": "jpk5ZG_mergedRow",
  "table": "jpk5ZG_table",
});
